// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 94592) return "static/chunks/" + chunkId + "-0d794989ae7e7a01.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "9aef46c027a06b39" + ".js";
};